import type { IEnvConfig } from "@aspen/model";
import { apikeyBugsnagProd } from "../../constant/base";

const staticHost = "https://static.aspendigital.co/";
export const preConfig: IEnvConfig = {
  env: "pre",
  host: {
    dev: "https://api2.aspendigital.co/",
    prod: "https://api2.aspendigital.co/"
  },
  klineChartUrl: `${staticHost}klinechart/index.html`,
  tvChartUrl: "https://tradingview-nextjs-javascript-git-green-aspendigital.vercel.app",
  websocket: {
    host: "wss://ws.aspendigital.co:8080"
  },
  apiKeyBugsnag: apikeyBugsnagProd,
  webDomain: "https://green-portal.aspendigital.co",
  appOnlyDomain: "https://green-apponly.aspendigital.co",
  domainUriPrefix: "https://pre-aspendigital.onelink.me/8NKn",
  fallbackUrl: {
    android:
      "https://install.appcenter.ms/orgs/kikitrade_ios/apps/Aspen_Android_Prod_Pre/distribution_groups/public/releases/96",
    ios: "https://install.appcenter.ms/orgs/kikitrade_ios/apps/aspen_ios_prod_pre/distribution_groups/public/releases/100"
  },
  packageName: {
    android: "com.pre.aspen",
    ios: "org.evg.pre.aspen"
  },
  minimumVersion: {
    android: "50",
    ios: "60"
  },
  operationServer: "https://api.aoperation.aspendigital.co/",
  saasServer: "https://api.asportal.co/",
  appScheme: "PreAspen"
};
